/*
 * The FeatureGate terminology comes from EXP.
 */

export enum FeatureGate {
  // debug
  EnableTestNav = "EnableTestNav",
  EnableTestTools = "EnableTestTools",
  EnableTestPages = "EnableTestPages",
  EnableCookieSourceDebugConsole = "EnableCookieSourceDebugConsole",
  DeveloperStoreRma = "DeveloperStoreRma",
  ShowStackOnError = "ShowStackOnError",
  StagingFD = "StagingFD",
}

export type FeatureGateValue = boolean | number | string | undefined;

export type FeatureGates = ReadonlyDictionary<FeatureGateValue>;
